/**
 * Component names reported by their `title.componentName`. Used by onboarding
 * surfaces (guide-banner) to gate behaviour on the active page. Strings must
 * match the @Component class name.
 */
export const START_COMPONENT_NAME = 'StartComponent';
export const VIEW_ASSETS_COMPONENT_NAME = 'ViewAssetsComponent';
